import React from 'react';
import { useI18n } from '../../contexts/I18nContext';
import { TransferStatus } from '../../types/deviceTransfer';

/** The status of a take-over request as a coloured badge. */
export const TransferStatusBadge: React.FC<{ status: TransferStatus }> = ({ status }) => {
  const { t } = useI18n();
  return <span className="pt-status" data-status={status}>{t(`portability.status.${status}`)}</span>;
};
